import * as types from './types'
import { openModal } from 'store/reducers/modals/actions'
import { MESSAGE_MODAL } from 'components/Modal/modalTypes'
import { USER_PROFILE, USER_PROFILE_BY_ID, ACTIONS } from 'common/endpoints'
import { push } from 'connected-react-router'

export const fetchUserProfile = nickname => ({
  type: types.FETCH_USER_PROFILE,
  meta: { url: `${USER_PROFILE}/${nickname}` },
})

export const fetchUserProfileById = id => ({
  type: types.FETCH_USER_PROFILE,
  meta: { url: `${USER_PROFILE_BY_ID}/${id}` },
})

export const like = (user, like = !user.inHotlist) => ({
  type: like ? types.ADD_FRIEND : types.REMOVE_FRIEND,
  meta: { url: ACTIONS.friend(user, like) },
  user,
})

export const wink = user => ({
  type: types.WINK,
  meta: { url: ACTIONS.wink(user) },
})

export const chat = user => ({
  type: types.CHAT,
  meta: {
    method: 'POST',
    url: ACTIONS.chat(user),
    onSuccess: ({ url }) => url && push(url),
    onError: data => /404|400/.test(data.code) && openModal(MESSAGE_MODAL, { message: data.userMessage }),
  },
})
